import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CharField } from 'components/forms'
import { FormattedSpeed } from 'shared/units'
import styles from './_workoutForm.css'

export default function Speed () {
  return (
    <CharField
      bold
      short
      name='speed'
      type='number'
      step='any'
      min='0'
      inputContainerClassName={styles.shortInput}
      labelComponent={(
        <FormattedMessage
          id='workouts.create.speed'
          defaultMessage='Avg. Speed'
        />
      )}
      afterComponent={(
        <span className={styles.fieldUnit}>
          <FormattedSpeed />
        </span>
      )}
    />
  )

}
